<template>
  <div class="headerWrapper">
    <v-app-bar-nav-icon
      class="d-flex d-sm-none"
      style="width: 50px; height: 50px"
      @click="toggleSideBar"
    ></v-app-bar-nav-icon>
    <v-toolbar-title class="mr-5">
      <router-link to="/" tag="span" style="cursor: pointer">
        <v-img
          max-height="41"
          max-width="120"
          src="/assets/readerLogo.svg"
          style="imgWrapper"
        ></v-img>
      </router-link>
    </v-toolbar-title>
    <div v-if="user === null" class="headerMenu">
      <div class="home">
        <div></div>
        <router-link class="link" to="/home" style="color: black">
          {{ $t("header.home") }}
        </router-link>
        <div class="bottom-light"></div>
      </div>
      <div class="home">
        <div></div>
        <router-link class="link" to="/plan" style="color: black">
          {{ $t("header.planInfo") }}
        </router-link>
        <div class="bottom-light"></div>
      </div>

      <!-- <v-menu bottom min-width="200px" rounded offset-y>
        <template v-slot:activator="{ on }">
          <span v-on="on" class="help">
            Тусламж <DownArrowIcon style="margin-left: 5px" />
          </span>
        </template>
        <v-card></v-card
      ></v-menu> -->
    </div>
    <v-spacer></v-spacer>

    <div class="countryFlagWrapper" @click="switchLocale">
      <country-flag
        v-if="toggleLocale"
        country="mn"
        size="normal"
        style="border-radius: 10px"
      ></country-flag>
      <country-flag
        v-else
        country="us"
        size="normal"
        style="border-radius: 10px"
      ></country-flag>
    </div>
    <v-menu v-if="user !== null" bottom min-width="320px" rounded offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon x-large v-on="on" class="button">
          <v-avatar color="#777ff6" size="24">
            <v-icon color="white" class="mdi-18px">mdi-account</v-icon>
          </v-avatar>
        </v-btn>
      </template>
      <v-card>
        <div class="user-header">
          <v-img
            max-height="24"
            max-width="24"
            src="/assets/ChimegeReader.svg"
            style="margin-left:20px"
          ></v-img>
          <div class="user-header-title">{{ $t("header.chimege") }}</div>

          <div class="user-logout" @click="logOut">
            {{ $t("logOut") }}
          </div>
        </div>

        <div class="user-info">
          <div class="avatar-placeholder">
            <v-avatar color="#777ff6" size="38">
              <v-icon color="white" large>mdi-account</v-icon>
            </v-avatar>
          </div>
          <div>
            <b>{{ getUsername }}</b>
            <div class="user-email">{{ user.Email }}</div>
            <router-link class="link profile-info" to="/profile">{{
              $t("header.myInfo")
            }}</router-link>
          </div>
        </div>
        <v-list>
          <v-divider></v-divider>
          <v-list-item href="https://wallet.bolor.net/login" target="_blank">
            <v-list-item-title>{{
              $t("header.financeInfo")
            }}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item link :to="'/orders'">
            <v-list-item-title>{{ $t("header.invoice") }}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item link :to="'/history'">
            <v-list-item-title>{{
              $t("header.paymentHistory")
            }}</v-list-item-title>
          </v-list-item>
          <!-- <v-divider></v-divider>
          <v-list-item link :to="'/plan'">
            <v-list-item-title>{{ $t("header.planInfo") }}</v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-card>
    </v-menu>
    <v-menu bottom min-width="200px" rounded offset-y offset-x>
      <template v-slot:activator="{ on }">
        <v-btn icon x-large v-on="on" class="button">
          <ProductionMenuIcon />
        </v-btn>
      </template>
      <v-card>
        <div class="product-title">
          <b>{{ $t("header.productTitle") }}</b>
        </div>
        <v-divider></v-divider>

        <div class="product-row">
          <a class="product-item">
            <v-img
              class="product-logo"
              max-height="41"
              max-width="41"
              src="/assets/ChimegeTungaamal.svg"
              style="imgWrapper"
            ></v-img>
            <p>{{ $t("header.product1") }}</p>
          </a>

          <a
            class="product-item"
            href="https://writer.chimege.mn"
            target="_blank"
          >
            <v-img
              class="product-logo"
              max-height="41"
              max-width="41"
              src="/assets/ChimegeWriter.svg"
              style="imgWrapper"
            ></v-img>
            <p>{{ $t("header.product2") }}</p>
          </a>

          <a class="product-item" href="https://kudos.mn" target="_blank">
            <v-img
              class="product-logo"
              max-height="41"
              max-width="41"
              src="/assets/BolorKudos.svg"
              style="imgWrapper"
            ></v-img>
            <p>{{ $t("header.product3") }}</p>
          </a>
        </div>
        <v-divider></v-divider>
        <div class="product-row">
          <a
            class="product-item"
            href="https://keyboard.chimege.mn"
            target="_blank"
          >
            <v-img
              class="product-logo"
              max-height="41"
              max-width="41"
              src="/assets/ChimegeKeyboard.svg"
              style="imgWrapper"
            ></v-img>
            <p>{{ $t("header.product4") }}</p>
          </a>

          <a class="product-item" style="background-color: #eceef5">
            <v-img
              class="product-logo"
              max-height="41"
              max-width="41"
              src="/assets/ChimegeReader.svg"
              style="imgWrapper"
            ></v-img>
            <p>{{ $t("header.product5") }}</p>
          </a>
        </div>
        <v-divider></v-divider>
      </v-card>
    </v-menu>
    <div class="login" @click="jump" v-show="user === null">
      {{ $t("header.login") }}
    </div>
    <v-snackbar
      :timeout="timeout"
      v-model="success"
      class="message"
      absolute
      center
      top
      color="green accent-6"
    >
      <v-icon left>mdi-check-circle-outline</v-icon>
      {{ info.success }}
    </v-snackbar>
    <v-snackbar
      :timeout="timeout"
      v-model="error"
      absolute
      class="message"
      center
      top
      color="red accent-6"
    >
      <v-icon left>mdi-alert-circle-outline</v-icon>
      {{ info.error }}
    </v-snackbar>
    <v-snackbar
      :timeout="timeout"
      v-model="warning"
      absolute
      center
      class="message"
      top
      color="warning"
    >
      <v-icon left>mdi-alert-octagon-outline</v-icon>
      {{ info.warning }}
    </v-snackbar>
  </div>
</template>
<script>
import ProductionMenuIcon from "./icons/ProductionMenuIcon";
import { StatusMessage, StreamRequest } from "../project_pb";
import { ProjectInfoClient } from "../project_grpc_web_pb";
import { mapActions, mapState } from "vuex";
export default {
  name: "Header",
  data: () => ({
    focus: "",
  }),
  props: {
    toggleLocale: Boolean,
    switchLocale: Function,
    noAuth: Function,
    toggleSideBar: { type: Function },
  },
  components: {
    ProductionMenuIcon,
  },
  created() {
    this.client = new ProjectInfoClient(
      process.env.VUE_APP_GRPC_URL,
      null,
      null
    );
  },

  computed: {
    ...mapState(["user", "info", "clientKey", "timeout"]),
    warning: {
      get() {
        return this.$store.state.snackbars.warning;
      },
      set() {
        this.clearWarningMessage();
      },
    },
    error: {
      get() {
        return this.$store.state.snackbars.error;
      },
      set() {
        this.clearErrorMessage();
      },
    },
    success: {
      get() {
        return this.$store.state.snackbars.success;
      },
      set() {
        this.clearSuccessMessage();
      },
    },
    getUserNameChar: function() {
      let username = this.user.Name;
      if (username === "") {
        username = this.user.Email;
      }
      return username.substring(0, 2).toUpperCase();
    },
    // getLoginURL: function() {
    //   return
    // },
    getUsername: function() {
      let username = this.user.Name;
      if (username === "") {
        username = "NoName";
      }
      return username;
    },
    getToken: function() {
      return this.$cookie.get("token");
    },
  },
  watch: {
    user: function() {
      if (this.user !== null && this.clientKey == null) {
        this.getClientKey();
      }
    },
  },

  methods: {
    ...mapActions([
      "clearSuccessMessage",
      "clearErrorMessage",
      "clearWarningMessage",
      "deleteUser",
      "setClientKey",
      "setAudioInfo",
      "setFileInfo",
    ]),
    getClientKey() {
      let params = new StatusMessage();
      this.client.getClientKey(
        params,
        {
          token: this.getToken,
        },
        (err, response) => {
          if (err) {
            console.log(err);
          } else {
            let data = response.toObject();
            const clientKey = data.clientKey;
            this.$cookie.set("clientKey", clientKey);
            this.setClientKey(clientKey);
            this.listenPercentChange();
            this.listenStatusChange();
          }
        }
      );
    },
    async listenPercentChange() {
      let params = new StreamRequest();
      params.setClientKey(this.clientKey);
      params.setCustomerId(this.user.CustomerID.toString());
      let call = this.client.getPercentChange(params, {
        token: this.getToken,
      });

      call.on("end", () => {
        console.log("percentChange ended");
      });
      call.on("data", (response) => {
        const data = response.toObject();
        if (data.status == "TIMEOUT") {
          this.listenPercentChange();
        } else {
          this.setAudioInfo(data);
        }
      });
      call.on("error", () => {
        setTimeout(() => {
          this.listenPercentChange();
        }, 4000);
      });
    },
    async listenStatusChange() {
      let params = new StreamRequest();
      params.setClientKey(this.clientKey);
      params.setCustomerId(this.user.CustomerID.toString());
      let call = this.client.getGroupStatusChange(params, {
        token: this.getToken,
      });

      call.on("data", (response) => {
        const data = response.toObject();
        if (data.status == "TIMEOUT") {
          this.listenStatusChange();
        } else {
          this.setFileInfo(data);
        }
      });
      call.on("end", () => {
        // call.end();
        console.log("end");
      });
      call.on("error", () => {
        setTimeout(() => {
          this.listenPercentChange();
        }, 4000);
      });
    },
    logOut() {
      this.$cookie.delete("token");
      this.deleteUser();
      this.$router.push({ name: "landing" });
      this.noAuth();
      this.closePercentKey();
      this.closeStatusKey();
    },
    jump() {
      window.location.href = process.env.VUE_APP_BASE_URL + "/login";
    },
  },
};
</script>
<style scoped>
.headerWrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 13px;
}

.countryFlagWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.button {
  outline: none !important;
  width: auto !important;
  height: auto !important;
  margin-left: 13px;
}

.product-title {
  padding: 6px;
  display: flex;
  justify-content: center;
}

.product-row {
  display: flex;
}

.product-item {
  width: 122px;
  height: 122px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-decoration: none !important;
  color: #000;
}
.product-logo {
  margin: 10px;
}
.product-item > p {
  font-size: 14px;
  margin: 0px;
}

.user-info {
  display: flex;
  align-items: center;
  padding-bottom: 6px;
}

.avatar-placeholder {
  margin: 20px;
  background-color: #777ff6;
  padding: 25px;
  border-radius: 50%;
}

.user-logout {
  padding: 12px 19px;
  cursor: pointer;
  font-size: 14px;
  margin-left: 86px;
}

.user-logout:hover {
  background-color: #eceef5;
}

.user-header {
  display: flex;
  align-items: center;
}

.user-header-title {
  color: #767676;
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
}

.user-email {
  font-size: 14px;
  color: #767676;
}

.bottom-light {
  width: 100%;
  height: 0px;
  border-radius: 2px;
  background-color: #777ff6;
}

.home {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 50px;
  margin: 0px 20px;
}

.help {
  display: flex;
  align-items: center;
  margin: 0px 20px;
}

.login {
  align-items: center;
  border-radius: 5px;
  background-color: #777ff6;
  font-size: 14px;
  font-weight: 500;
  color: white;
  margin-left: 13px;
  padding: 4px  10px 4px 10px;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
}

.message {
  margin-top: 50px;
}

.headerMenu {
  display: flex;
}
.profile-info {
  color: #777ff6;
  font-size: 14px;
  cursor: pointer;
}
@media screen and (max-width: 599px) {
  .countryFlagWrapper {
    display: none;
  }
  .headerMenu {
    display: none;
  }
}
</style>
